import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_MAP_ASSESSOR
} from "@routes";

const apiConfig = [
  {
    name: "updateMapAssessor",
    method: "put",
    url: CRUD_MAP_ASSESSOR,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    mapAssessorsData: [],
    notMappedAssessorsData: [],
    selectedData: {},
  },

  reducers: {
  },

  extraReducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "mapAssessor",
  apiConfig,
  customReducers,
);

const mapAssessorSlice = slice;

export default mapAssessorSlice.reducer;

export const {
  updateMapAssessor,
} = thunks;

export const {
  rowSelect
} = actions;